import { Common } from '@thecvlb/design-system/lib/src';

import { BasicSignupStepProps } from 'containers/SignUp/Content/content.types';

import { FlowTypes } from 'utils/enums';
import { calculateDiscountPercentageByPrices } from 'utils/helpers';

const MarketingScreenCompareToOthers: React.FC<BasicSignupStepProps> = ({
  selectedFlow,
  moveToStep
}) => {
  return (
    <div className="mx-auto flex h-full max-w-[500px] flex-col items-center gap-6">
      <div className="flex flex-col gap-3 md:gap-6">
        <div>
          <h1 className="text-center text-mXl text-primary-700 md:text-2xl">
            Join over <b>745,000 LifeMD patients,</b> and feel confident about achieving your weight
            loss goals.
          </h1>
          <p className="mt-2 text-center text-primary-700">
            {selectedFlow === FlowTypes.WeightManagementBalladHealth
              ? `We’re committed to providing transparency throughout your entire journey, from the cost of your medication to the status of your prescription.`
              : `We’re committed to providing transparency throughout your entire journey, from the cost
            of your medication to the status of your prescription to the coverage provided by your
            insurance.`}
          </p>
        </div>
        <div className="flex">
          <div className="flex basis-full flex-col">
            <p className="h-10 text-center text-mSm opacity-0">&nbsp;</p>
            {[
              'Personalized prescriptions',
              'Expert clinician consultations',
              'Monthly provider guidance',
              'Tailored treatment plans'
            ].map((item) => (
              <p
                className="flex h-10 items-center p-2 text-mSm text-primary-700 even:rounded-l-lg even:bg-primary-100"
                key={item}
              >
                {item}
              </p>
            ))}
          </div>
          <div className="flex basis-0">
            <div className="flex flex-col rounded-lg border border-solid border-gray-200 bg-white pb-3">
              <p className="flex h-10 items-center p-2 text-center text-mSm text-primary">LifeMD</p>
              {[...Array(4).keys()].map((_, index) => (
                <Common.Icon className="h-10 w-full p-2 text-secondary" key={index} name="check" />
              ))}
            </div>
            <div className="flex flex-col">
              <p className="flex h-10 items-center p-2 text-center text-mSm text-primary">Others</p>
              {[...Array(4).keys()].map((_, index) => (
                <Common.Icon
                  className="h-10 w-full p-2 text-primary even:rounded-r-lg even:bg-primary-100"
                  key={index}
                  name="close"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col gap-2 max-md:mt-auto md:self-center">
        <Common.Button
          className="md:mx-auto"
          color="blue"
          fullWidthOnMobile
          onClick={() => moveToStep('next')}
        >
          Continue
        </Common.Button>
        {selectedFlow === FlowTypes.BlueLineFlow && (
          <span className="text-center text-primary">
            <span className="font-bold">Special Offer: </span>Save Up To{' '}
            {calculateDiscountPercentageByPrices(59, 149)}%
          </span>
        )}
      </div>
    </div>
  );
};

export default MarketingScreenCompareToOthers;
